"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Loader_1 = require("wix-style-react/Loader");
var Dropdown_1 = require("../Dropdown/Dropdown");
var Translate_1 = require("./../../Translate/Translate");
var s = require("./AutoComplete.scss");
var getItemTranslation = function (items, itemCode) {
    var itemValue = items.find(function (item) { return item.value === itemCode; });
    return itemValue ? itemValue.label : itemCode;
};
var AutoComplete = (function (_super) {
    __extends(AutoComplete, _super);
    function AutoComplete(props) {
        var _this = _super.call(this, props) || this;
        _this.getAutocompleteCachedItems = function () { return AutoComplete.cachedItems[_this.props.name] || []; };
        _this.handleDefaultValueTranslation = function (items) {
            _this.setState({
                itemCode: getItemTranslation(items, _this.state.itemCode),
                items: (_this.getAutocompleteCachedItems()).filter(function (item) {
                    return item.label === getItemTranslation(items, _this.state.itemCode);
                }),
            });
        };
        _this.handleTextChange = function (e) {
            var items = (_this.getAutocompleteCachedItems()).filter(function (item) {
                var label = item.label.toLowerCase();
                var mask = e.target.value.toLowerCase();
                return item.value.indexOf(e.target.value) === 0 || label.indexOf(mask) === 0;
            });
            if (items.length === 1 && items[0].label === e.target.value) {
                _this.handleSelect(items[0]);
                /* istanbul ignore next */
                if (_this.dropdownNode) {
                    _this.dropdownNode.hideDropdownMenu();
                }
            }
            _this.setState({
                items: items,
                itemCode: e.target.value,
            });
        };
        _this.mapItemsToOptionsFormat = function (items) {
            return items.map(function (item) {
                return {
                    id: item.key,
                    value: item.key,
                    label: item.displayName,
                };
            });
        };
        _this.handleFocus = function () {
            if (!(_this.getAutocompleteCachedItems()).length) {
                _this.fetchItems();
            }
        };
        _this.fetchItems = function (callback) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // TODO here instead of xhr we should use client for wix-metadata-service
                this.setState({ isLoadingOptions: true });
                if (!this.props.fetchItems) {
                    return [2 /*return*/, null];
                }
                this.props.fetchItems(this.props.locale)
                    .then(function (rawItems) {
                    var items = _this.mapItemsToOptionsFormat(rawItems);
                    AutoComplete.cachedItems[_this.props.name] = items;
                    _this.setState({
                        items: items,
                        isLoadingOptions: false,
                    });
                    if (callback) {
                        callback(items);
                    }
                })
                    .catch(function (e) { return console.error(e); });
                return [2 /*return*/];
            });
        }); };
        _this.isError = function () { return !_this.props.isValid && _this.props.touched; };
        _this.handleSelect = function (option) {
            _this.setState({
                itemCode: option.label,
            });
            if (_this.props.onChange) {
                _this.props.onChange({
                    value: option.id,
                    name: _this.props.name,
                    isValid: _this.props.validate(option.id),
                });
            }
        };
        _this.state = {
            itemCode: getItemTranslation(_this.getAutocompleteCachedItems(), _this.props.value || ''),
            isLoadingOptions: false,
            items: _this.getAutocompleteCachedItems().filter(function (item) {
                return item.label === getItemTranslation(_this.getAutocompleteCachedItems(), _this.props.value || '');
            }),
        };
        return _this;
    }
    AutoComplete.prototype.componentDidMount = function () {
        if (!this.getAutocompleteCachedItems().length) {
            if (this.state.itemCode && this.state.itemCode.length === 3) {
                this.fetchItems(this.handleDefaultValueTranslation);
            }
            else {
                this.fetchItems();
            }
        }
    };
    AutoComplete.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.name === 'state' && this.props.countryCode !== prevProps.countryCode) {
            this.fetchItems();
        }
    };
    AutoComplete.prototype.renderErrorMessage = function () {
        if (!this.isError() || !this.props.errorMessage) {
            return null;
        }
        return (React.createElement("label", { "data-hook": "cashier-payments-method-autoComplete-dropdown-error", className: s.errorLabel, htmlFor: name }, Translate_1.translate({ forKey: this.props.errorMessage })));
    };
    AutoComplete.prototype.render = function () {
        var _this = this;
        var _a = this.props, required = _a.required, value = _a.value, name = _a.name, label = _a.label;
        return (React.createElement("div", { className: s.root, "data-hook": "cashier-payments-method-AutoComplete-dropdown" },
            React.createElement("label", { className: s.label, htmlFor: name },
                required ? '* ' : '',
                Translate_1.translate({ forKey: label })),
            this.state.isLoadingOptions
                ? React.createElement("div", { className: s.loader },
                    React.createElement(Loader_1.default, { size: "small" }))
                : null,
            React.createElement(Dropdown_1.default, { ref: function (node) { return _this.dropdownNode = node; }, disabled: this.state.isLoadingOptions, isLoadingOptions: this.state.isLoadingOptions, autocompleteInputValue: this.state.itemCode, autocomplete: true, defaultOptionId: value, options: this.state.items, onSelect: this.handleSelect, onChange: this.handleTextChange, onFocus: this.handleFocus }),
            this.renderErrorMessage()));
    };
    AutoComplete.cachedItems = {};
    AutoComplete.defaultProps = {
        locale: 'en',
    };
    return AutoComplete;
}(React.Component));
exports.default = AutoComplete;
//# sourceMappingURL=AutoComplete.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Fields/AutoComplete/AutoComplete.js
// module id = 197
// module chunks = 0 1